import BaseWrapper from "../BaseWrapper";
import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from "@clayui/date-picker";
import dayjs from "dayjs";
import { useEffect } from "react";
import ClayIcon from '@clayui/icon';

type FormInputProps = {
    name: string;
    label?: string;
    type?: string;
    readonly?: boolean;
    disabled?: boolean;
    groupClassName?: string;
    required?: boolean;
    onChangeWithFocus?: (elementId: string) => void;
    onClear: (fieldName: string) => void;
};

export function FormInputDate(props: FormInputProps) {
    useEffect(() => {
        const input = document.querySelector(`#${props.name}`) as HTMLInputElement;
        if (input && props.required) {
            input.setAttribute("aria-required", "true");
        }
        input.readOnly = true;
      }, [props.name, props.required]);

    return (
        <Controller
            name={props.name}
            render={({ field, fieldState }) => (
                <BaseWrapper
                    error={fieldState?.error?.message}
                    id={props.name}
                    label={props.label}
                    required={props.required}
                    groupClassName={props.groupClassName}
                >
                    <DatePicker
                        id={props.name}
                        onChange={(e: string) => {
                            field.onChange(e === '' ? null : e);
                            if(props.onChangeWithFocus) {
                                props.onChangeWithFocus(props.name);
                            }
                        }}
                        disabled={props.disabled}
                        placeholder="DD.MM.RRRR"
                        value={field.value ? dayjs(field.value).format('DD.MM.YYYY') : ""}
                        years={{
                            end: 2040,
                            start: 1997,
                        }}
                        firstDayOfWeek={1}
                        months={[
                            "Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec",
                            "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"
                        ]}
                        weekdaysShort={["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "Sb"]}
                        ariaLabels={{
                            buttonChooseDate: "Otwórz wybór daty",
                            buttonDot: "Dzisiejsza data",
                            buttonNextMonth: "Następny miesiąc",
                            buttonPreviousMonth: "Poprzedni miesiąc",
                            selectMonth: "Wybierz miesiąc",
                            selectYear: "Wybierz rok",
                        }}
                    />
                   {field.value && (
                    <button
                        type="button"
                        className="btn btn-unstyled position-absolute"
                        style={{ right: '46px', top: '33px', zIndex: '1', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '30px', width: '30px' }}
                        onClick={() => props.onClear(field.name)}
                    >
                        <ClayIcon symbol="times" />
                    </button>)}
                </BaseWrapper>
            )}
        />
    );
}
